module.exports = __webpack_public_path__ + "img/blog-3.b06bd5e5.jpg";